export { templatesGet } from '@/app/services/vidu';
